import { InjectionToken } from '@angular/core';

export const IS_BOT = new InjectionToken<boolean>('IS_BOT'/*, {
  providedIn: 'root',
  factory: () => false,
}*/);
